// extracted by mini-css-extract-plugin
export default {"marginBottomSmall":"ActivityList_marginBottomSmall__YYogC","marginTopLarge":"ActivityList_marginTopLarge__9jSQT"};